import * as Sentry from '@sentry/vue';
import { computed, ref } from 'vue';
import { doc, getAuth, onSnapshot, query } from 'shared/services/firebase';

export default function useCurrentUser(db, subscriptionManager) {
  const auth = getAuth();
  const user = ref(null);
  const loading = ref(true);
  auth.onAuthStateChanged(async (u) => {
    if (u === null) {
      loading.value = false;
      user.value = null;
      dbUser.value = {};
      localStorage.setItem('userLoggedIn', 'false');
      return;
    }
    localStorage.setItem('userLoggedIn', 'true');
    user.value = u;
    Sentry.setUser({ uid: user.value.uid });
    await retrieveUser(user.value.uid);
    await retrieveSubscriptionData(user.value.uid);
  });

  const dbUser = ref({});
  const retrieveUser = async (uid) => {
    dbUser.value = {};
    const q = query(doc(db, 'users', uid));
    const unsubscribe = onSnapshot(q, (querySnapShot) => {
      if (!querySnapShot.exists()) {
        return;
      }
      dbUser.value = querySnapShot.data();
    });
    subscriptionManager.addSubscriber(unsubscribe, { auth: true });
  };

  const subscriptionData = ref({});
  const retrieveSubscriptionData = async (uid) => {
    const q = query(doc(db, 'users', uid, 'private', 'subscriptionData'));
    const unsubscribe = onSnapshot(
      q,
      (querySnapShot) => {
        if (!querySnapShot.exists()) {
          return;
        }
        subscriptionData.value = querySnapShot.data();
        loading.value = false;
      },
    );
    subscriptionManager.addSubscriber(unsubscribe, { auth: true });
  };

  const currentUser = computed(() => {
    if (user.value === null) {
      return null;
    }
    return { ...user.value, ...dbUser.value, subscriptionData: subscriptionData.value };
  });

  return { currentUser, loading, subscriptionData };
}
